export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/f3ee8701b883937bc520e8fddc6bcc4d/a1bb830a37e1820e7bca1d593143873a.png"
              alt="Feel Music"
              className="h-20 mb-4"
            />
            <p className="text-gray-400 leading-relaxed mb-6">
              Há mais de 20 anos criando experiências musicais inesquecíveis para eventos corporativos e sociais de alto padrão.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/produtorafeelmusic"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-purple-600 text-white transition-all duration-300 hover:scale-110 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://wa.me/5511970172813"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-green-500 to-green-600 text-white transition-all duration-300 hover:scale-110 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a
                href="https://www.youtube.com/@ProdutoraFeelMusic"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-red-500 to-red-600 text-white transition-all duration-300 hover:scale-110 cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
            <div className="mt-6 space-y-2">
              <a href="tel:+5511970172813" className="flex items-center gap-2 text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                <i className="ri-phone-line"></i>
                <span>11 97017-2813</span>
              </a>
              <a href="mailto:contato@feelmusic.com.br" className="flex items-center gap-2 text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
                <span>contato@feelmusic.com.br</span>
              </a>
            </div>
          </div>

          {/* Projetos */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Nossos Artistas</h4>
            <ul className="space-y-3">
              <li>
                <a href="#portfolio" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Banda M7
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Coral Mozart
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Dixie
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Happy Hour
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Villa Voice
                </a>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Quem Somos
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Portfólio
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Serviços
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-amber-500 transition-colors cursor-pointer">
                  Contato
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Feel Music. Todos os direitos reservados.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 text-sm hover:text-amber-500 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/5511970172813"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 w-16 h-16 flex items-center justify-center bg-gradient-to-r from-green-500 to-green-600 rounded-full text-white shadow-2xl transition-all duration-300 hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>
    </footer>
  );
}
